/**
 * Shared PWA install helpers for login + in-app banners.
 */

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export function isIosDevice() {
  if (typeof window === 'undefined') return false;
  return (
    /iphone|ipad|ipod/i.test(window.navigator.userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
  );
}

export function isAndroidDevice() {
  if (typeof window === 'undefined') return false;
  return /android/i.test(window.navigator.userAgent);
}

/** Module-level deferred beforeinstallprompt event (Chromium). */
let deferredInstallPrompt = null;
const listeners = new Set();

export function getDeferredInstallPrompt() {
  return deferredInstallPrompt;
}

export function subscribeInstallPrompt(listener) {
  listeners.add(listener);
  if (deferredInstallPrompt) listener(deferredInstallPrompt);
  return () => listeners.delete(listener);
}

export function captureInstallPromptEvent(e) {
  e.preventDefault();
  deferredInstallPrompt = e;
  listeners.forEach((fn) => {
    try {
      fn(e);
    } catch {
      // ignore
    }
  });
}

export async function promptPwaInstall() {
  const deferred = deferredInstallPrompt;
  if (!deferred) return { ok: false, reason: 'unavailable' };
  deferred.prompt();
  try {
    const choice = await deferred.userChoice;
    deferredInstallPrompt = null;
    return { ok: choice?.outcome === 'accepted', outcome: choice?.outcome };
  } catch {
    return { ok: false, reason: 'cancelled' };
  }
}

/** Call once from app bootstrap so login page can install. */
export function initPwaInstallCapture() {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', captureInstallPromptEvent);
}
